<template>
  <div v-if="isShowContent" class="education-fields">
    <BaseSelect
      v-model="typeSelectedId"
      :options="typesDictionary"
      :label="'Тип учебного заведения'"
      value-key="id"
      label-key="name"
      @input="handleTypeSelectInput"
    >
      <template v-slot:option="{ option }">
        <div :id="option.id">{{ option.name }}</div>
      </template>
      <template v-slot:selected-option="{ option }">
        <div :id="option.id">{{ option.name }}</div>
      </template>
    </BaseSelect>

    <BaseSelect
      v-if="typeSelectedId"
      v-model="citySelectedId"
      :options="citiesDictionary"
      :label="'Город учебного заведения'"
      value-key="id"
      label-key="name"
      @filter="handleEduCitySelectFilter"
      @input="handleCitySelectInput"
    >
      <template v-slot:option="{ option }">
        <div :id="option.id">
          {{ getCityOptionString(option.title, option.region) }}
        </div>
      </template>
      <template v-slot:selected-option="{ option }">
        <div :id="option.id">
          {{ getCityOptionString(option.title, option.region) }}
        </div>
      </template>
    </BaseSelect>

    <BaseSelect
      v-if="citySelectedId"
      v-model="nameSelectedId"
      :options="namesDictionary"
      :label="'Учебное заведение'"
      value-key="id"
      label-key="title"
      @filter="handleEduNameSelectFilter"
      @input="handleNameSelectInput"
    >
      <template v-slot:option="{ option }">
        <div :id="option.id">{{ option.title }}</div>
      </template>
      <template v-slot:selected-option="{ option }">
        <div :id="option.id">{{ option.title }}</div>
      </template>
    </BaseSelect>
  </div>
</template>

<script>
import BaseSelect from '@components/BaseComponents/Form/Select.vue';

export default {
  name: 'EducationFileds',
  components: {
    BaseSelect,
  },

  data() {
    return {
      isShowContent: false,

      typeSelectedId: 0,
      citySelectedId: 0,
      nameSelectedId: 0,

      citySearchString: '',
      nameSearchString: '',

      cities: [],
      names: [],
    };
  },

  computed: {
    ...mapGetters('profile', ['getCurrentProfile']),

    eduType() {
      return this.typesDictionary.find(
        (edt) => edt.id === this.typeSelectedId,
      ).type;
    },

    typesDictionary() {
      return [
        { id: 0, name: 'Не учусь', type: 'none' },
        { id: 1, name: 'Школа', type: 'school' },
        { id: 2, name: 'Вуз', type: 'university' },
      ];
    },
    citiesDictionary() {
      return [
        {
          id: 0,
          title: 'Не указано',
          area: '',
          region: '',
        },
        ...this.cities,
      ];
    },
    namesDictionary() {
      return [{ id: 0, title: 'Не указано' }, ...this.names];
    },

    emitData() {
      return {
        type: this.eduType,
        cityId: this.citySelectedId || null,
        eduId: this.nameSelectedId || null,
      };
    },
  },

  async created() {
    const { eduType, eduId, eduInfo } = this.getCurrentProfile;

    if (eduInfo) {
      this.typeSelectedId = this.typesDictionary.find(
        (t) => t.type === eduType,
      ).id;
      this.nameSelectedId = eduId;

      this.citySearchString = eduInfo.city;
      this.nameSearchString = eduInfo.name;

      await this.fetchEduCities();
      this.citySelectedId = this.citiesDictionary.find(
        (c) => c.title === eduInfo.city,
      ).id;
      await this.fetchEduNames();
      this.names.unshift({ id: eduId, title: eduInfo.name });
    } else {
      await this.fetchEduCities();
      await this.fetchEduNames();
    }

    this.isShowContent = true;
  },

  methods: {
    getCityOptionString(title, region) {
      return `${title}${region ? ', ' + region : ''}`;
    },

    async fetchEduCities() {
      const data = await api.get('/dict/city', {
        params: {
          query: this.citySearchString,
        },
      });

      this.cities = data.cities;
    },

    async fetchEduNames() {
      if (!this.typeSelectedId) return;

      const data = await api.get('/dict/' + this.eduType, {
        params: {
          query: this.nameSearchString,
          cityId: this.citySelectedId,
        },
      });

      if (this.eduType === 'school') {
        this.names = data.schools;
      } else {
        this.names = data.universities;
      }
    },

    handleEduCitySelectFilter(searchString) {
      this.citySearchString = searchString;
      this.fetchEduCities();
    },

    handleEduNameSelectFilter(searchString) {
      this.nameSearchString = searchString;
      this.fetchEduNames();
    },

    handleTypeSelectInput() {
      this.citySearchString = '';
      this.nameSearchString = '';
      this.citySelectedId = 0;
      this.nameSelectedId = 0;
      this.fetchEduCities();
      this.$emit('change', this.emitData);
    },
    handleCitySelectInput() {
      this.fetchEduNames();
      if (!this.citySelectedId) {
        this.nameSelectedId = 0;
      }
      this.$emit('change', this.emitData);
    },
    handleNameSelectInput() {
      this.$emit('change', this.emitData);
    },
  },
};
</script>

<style lang="scss">
.education-fields {
  margin-top: 8px;
}
</style>
